import { PORTFOLIO_CONSTS as PORTFOLIO_CONSTS_CONST } from '@modules/edit-preference/components/portfolio/portfolio.contants';

export const PORTFOLIO_BANNER_VIEW_CONSTS = {
  DISPLAY_THIS_PORTFOLIO: 'Display this Portfolio',
  DISABLE_THIS_PORTFOLIO: 'Disable this Portfolio',
  EDIT_PORTFOLIO: 'Edit Portfolio',
  ENABLE: 'Enable',
  DISABLE: 'Disable',
  NO_MUSIC_ADDED: 'No Albums Added Yet',
  NO_VIDEO_ADDED: 'No Video Series Added Yet',
  NO_COLLECTION_ADDED: 'No Collections Added Yet',
  NO_PODCAST_ADDED: 'No Podcasts Added Yet',
  NO_ITEMS_ADDED: 'No Items Added Yet',
  NO_CUSTOM_ADDED: 'No Portfolio Items Added Yet',
  NO_CUSTOM_ADDED_MSG: 'Add your first Custom Portfolio Collection or Single Item',
  ADD_FIRST_ALBUM_OR_SONG: 'Add your first Album or Single Song',
  ADD_FIRST_ALBUM: 'Add your first Album',
  ADD_FIRST_VIDEO: 'Add your first Video Series',
  ADD_FIRST_PODCAST: 'Add your first Podcast Series',
  ADD_FIRST_ITEM: 'Add your first Item',
  ADD_FIRST_COLLECTION: 'Add your first Collection',
  ADD_ALBUM: 'ADD ALBUM',
  ADD_VIDEO: 'ADD VIDEO SERIES',
  ADD_PODCAST: 'ADD PODCAST SERIES',
  ADD_ITEM: 'ADD ITEM',
  ADD_SINGLE_ITEMS: 'ADD SINGLE ITEMS',
  ADD_SINGLE_ITEM: 'ADD SINGLE ITEM',
  ADD_COLLECTION_ITEM: 'ADD NEW COLLECTION',
  ITEMS: 'Items',
  LOADING: 'Loading...',
  READ_MORE: 'Read More',
  READ_LESS: 'Read Less',
  ALBUMS: 'ALBUMS',
  VIDEO_SERIES: 'VIDEO SERIES',
  PODCAST_SERIES: 'PODCAST SERIES',
  COLLECTIONS: 'COLLECTIONS',
  INDIVIDUAL_SONGS: 'INDIVIDUAL SONGS',
  INDIVIDUAL_VIDEOS: 'INDIVIDUAL VIDEOS',
  INDIVIDUAL_PODCASTS: 'INDIVIDUAL PODCASTS',
  SINGLE_SONGS: 'SINGLE SONGS',
  SINGLE_VIDEOS: 'SINGLE VIDEOS',
  SINGLE_EPISODES: 'SINGLE EPISODES',
  SINGLE_ITEMS: 'SINGLE ITEMS',
  ADD_SINGLE_SONG: 'ADD SINGLE SONG',
  ADD_SINGLE_VIDEO: 'ADD SINGLE VIDEO',
  ADD_SINGLE_EPISODE: 'ADD SINGLE EPISODE',
  RE_ORDER: 'RE-ORDER',
  SONG: 'Song',
  SONGS: 'Songs',
  VIDEO: 'Video',
  VIDEOS: 'Videos',
  PODCAST: 'Podcast',
  PODCASTS: 'Podcasts',
  ITEM: 'Item',
  TAB_ALBUMS: 'albums',
  TAB_INDIVIDUAL: 'individual',
  ITEM_TYPE_ALBUM: 'album',
  ITEM_TYPE_INDIVIDUAL_SONG: 'individual_song',
  ITEM_TYPE_INDIVIDUAL_VIDEO: 'individual_video',
  ITEM_TYPE_INDIVIDUAL_PODCAST: 'individual_podcast',
  FAILED_TO_LOAD_ALBUMS: 'Failed to load albums',
  ICON_PORTFOLIO_NOT_FOUND: 'icon-liteportfolio-not-found',
  ICON_HEADPHONES: 'icon-litemusic-node-2',
  ICON_VIDEO: 'icon-litevideo-fill-camera',
  ICON_PODCAST: 'icon-liteMIc-Icon',
  ICON_SUITCASE: 'icon-litesuitcase',
  FAILED_TO_LOAD_PORTFOLIO: 'Failed to load portfolio',
  PORTFOLIO_NOT_FOUND: 'Portfolio not found',
  DISABLED: 'Disabled',
  DRAFTED: 'Draft',
  DELETE_PORTFOLIO_MSG: 'Are you sure you want to delete this portfolio?',
  DELETE_PORTFOLIO: 'Delete Portfolio',
  PORTFOLIO_DELETED_SUCCESS: 'Portfolio deleted successfully',
  PORTFOLIO_UPDATED_SUCCESS: 'Portfolio updated successfully',
  FAILED_TO_UPDATE_PORTFOLIO: 'Failed to update portfolio',
  SEQUENCE_NUMBERS_UPDATED_SUCCESS: 'Sequence numbers updated successfully',
  FAILED_TO_UPDATE_SEQUENCE_NUMBERS: 'Failed to update sequence numbers',
  DELETE_ALBUM_MSG: 'Are you sure you want to delete the album, {{title}}?',
  DELETE_ALBUM: 'Delete Album',
  ALBUM_DELETED_SUCCESS: 'Album deleted successfully',
  FAILED_TO_DELETE_ALBUM: 'Failed to delete album',
  TYPE_FIRST: 'first',
  TYPE_SECOND: 'second',
  ADD_ITEMS_TO_PORTFOLIO_MSG: 'Please add an item to enable displaying this Portfolio on your TopFans site',
  DELETE_SERIES: 'Delete Podcast Series',
  DELETE_SERIES_MSG: 'Are you sure you want to delete the podcast series, {{title}}?',
  DELETE_MASTER_DATA_TITLE: {
    MUSIC: 'Delete Album',
    VIDEO: 'Delete Video Series',
    PODCAST: 'Delete Podcast Series',
    CUSTOM: 'Delete Collection',
  },
  DELETE_MASTER_DATA_MESSAGE: {
    MUSIC: 'Are you sure you want to delete the album, {{title}}?',
    VIDEO: 'Are you sure you want to delete the video series, {{title}}?',
    PODCAST: 'Are you sure you want to delete the podcast series, {{title}}?',
    CUSTOM: 'Are you sure you want to delete the collection, {{title}}?',
  },
  SINGLE_ITEMS_SM: 'Single Items',
  COLLECTIONS_SM: 'Collections',
  PORTFOLIO_SM: 'Portfolio',
  VIEW_SIMILAR: 'View Similar',
  VIEW_SIMILAR_PORTFOLIO_PARENT_PREFIX: 'More From This ',
  BREADCRUMB_SEPARATOR: ' > ',
};

export const VIEW_SIMILAR_ALBUM_PARENT_TITLE_BY_PORTFOLIO_TYPE: Record<
  string,
  string
> = {
  MUSIC: 'More From This Album',
  VIDEO: 'More From This Video Series',
  PODCAST: 'More From This Podcast',
  CUSTOM: 'More From This Collection',
};

export const PORTFOLIO_MASTER_DESCRIPTION_TITLE_MAP = {
  MUSIC: PORTFOLIO_CONSTS_CONST.ALBUM_DESCRIPTION,
  VIDEO: PORTFOLIO_CONSTS_CONST.VIDEO_SERIES_DESCRIPTION,
  PODCAST: PORTFOLIO_CONSTS_CONST.PODCAST_SERIES_DESCRIPTION,
  CUSTOM: PORTFOLIO_CONSTS_CONST.COLLECTION_DESCRIPTION,
}

export const PORTFOLIO_SINGLE_DESCRIPTION_TITLE_MAP = {
  MUSIC: PORTFOLIO_CONSTS_CONST.SONG_DESCRIPTION,
  VIDEO: PORTFOLIO_CONSTS_CONST.VIDEO_DESCRIPTION,
  PODCAST: PORTFOLIO_CONSTS_CONST.PODCAST_DESCRIPTION,
  CUSTOM: PORTFOLIO_CONSTS_CONST.ITEM_DESCRIPTION,
}

export const PORTFOLIO_TITLE_HEADING_MAP = {
  MUSIC: 'Music',
  VIDEO: 'Video',
  PODCAST: 'Podcast',
  CUSTOM: 'Custom Portfolio',
}

export const PORTFOLIO_MASTER_TYPE_LABEL_MAP = {
  MUSIC: 'Album',
  VIDEO: 'Series',
  PODCAST: 'Series',
  CUSTOM: 'Collection',
}

export const PORTFOLIO_TYPE_ICON_MAP = {
  MUSIC: PORTFOLIO_BANNER_VIEW_CONSTS.ICON_HEADPHONES,
  VIDEO: PORTFOLIO_BANNER_VIEW_CONSTS.ICON_VIDEO,
  PODCAST: PORTFOLIO_BANNER_VIEW_CONSTS.ICON_PODCAST,
  CUSTOM: PORTFOLIO_BANNER_VIEW_CONSTS.ICON_SUITCASE,
};

export const PORTFOLIO_SINGLE_ADD_EDIT_ROUTE_PATH_MAP = {
  MUSIC: 'add-edit-single-song-portfolio',
  VIDEO: 'add-edit-individual-video',
  PODCAST: 'add-edit-individual-podcast',
  CUSTOM: 'add-edit-single-item-portfolio',
};

export const PORTFOLIO_MASTER_ADD_EDIT_ROUTE_PATH_MAP = {
  MUSIC: 'add-edit-album-portfolio',
  VIDEO: 'add-edit-video-portfolio',
  PODCAST: 'add-edit-podcast-portfolio',
  CUSTOM: 'add-edit-collection-portfolio',
};

export const PORTFOLIO_DETAIL_ROUTE_PATH_MAP = {
  MUSIC: 'music-detail',
  VIDEO: 'video-detail',
  PODCAST: 'podcast-detail',
  CUSTOM: 'item-detail',
};

export const PORTFOLIO_MASTER_ROUTE_PATH_MAP = {
  MUSIC: 'music-album',
  VIDEO: 'video-series',
  PODCAST: 'podcast-series',
  CUSTOM: 'collection-detail',
};

export const PORTFOLIO_INDIVIDUAL_SHARE = {
  MUSIC: PORTFOLIO_CONSTS_CONST.INDIVIDUAL_MUSIC_SHARE_MSG,
  VIDEO: PORTFOLIO_CONSTS_CONST.INDIVIDUAL_VIDEO_SHARE_MSG,
  PODCAST: PORTFOLIO_CONSTS_CONST.INDIVIDUAL_PODCAST_SHARE_MSG,
  CUSTOM: PORTFOLIO_CONSTS_CONST.INDIVIDUAL_CUSTOM_ITEM_SHARE_MSG,
}

export const PORTFOLIO_MASTER_SHARE = {
  MUSIC: PORTFOLIO_CONSTS_CONST.MUSIC_ALBUM_SHARE_MSG,
  VIDEO: PORTFOLIO_CONSTS_CONST.VIDEO_SERIES_SHARE_MSG,
  PODCAST: PORTFOLIO_CONSTS_CONST.PODCAST_ALBUM_SHARE_MSG,
  CUSTOM: PORTFOLIO_CONSTS_CONST.COLLECTION_ITEM_SHARE_MSG,
}

export const PORTFOLIO_SINGLE_CONTENT_TYPE_LABEL = {
  MUSIC: PORTFOLIO_BANNER_VIEW_CONSTS.SONG,
  VIDEO: PORTFOLIO_BANNER_VIEW_CONSTS.VIDEO,
  PODCAST: PORTFOLIO_BANNER_VIEW_CONSTS.PODCAST,
  CUSTOM: PORTFOLIO_BANNER_VIEW_CONSTS.ITEM,
}

export const PORTFOLIO_MULTIPLE_CONTENT_TYPE_LABEL = {
  MUSIC: PORTFOLIO_BANNER_VIEW_CONSTS.SONGS,
  VIDEO: PORTFOLIO_BANNER_VIEW_CONSTS.VIDEOS,
  PODCAST: PORTFOLIO_BANNER_VIEW_CONSTS.PODCASTS,
  CUSTOM: PORTFOLIO_BANNER_VIEW_CONSTS.ITEMS,
}

export const OUTER_ADD_BUTTON_LABEL_MAP = {
  MUSIC: {
    SINGLE: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_SINGLE_SONG,
    MASTER: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_ALBUM,
  },
  VIDEO: {
    SINGLE: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_SINGLE_VIDEO,
    MASTER: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_VIDEO,
  },
  PODCAST: {
    SINGLE: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_SINGLE_EPISODE,
    MASTER: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_PODCAST,
  },
  CUSTOM: {
    SINGLE: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_SINGLE_ITEM,
    MASTER: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_COLLECTION_ITEM,
  },
}

export const EMPTY_STATE_MESSAGE_MAP = {
  MUSIC: {
    TITLE: PORTFOLIO_BANNER_VIEW_CONSTS.NO_MUSIC_ADDED,
    MSG: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_FIRST_ALBUM_OR_SONG,
  },
  VIDEO: {
    TITLE: PORTFOLIO_BANNER_VIEW_CONSTS.NO_VIDEO_ADDED,
    MSG: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_FIRST_VIDEO,
  },
  PODCAST: {
    TITLE: PORTFOLIO_BANNER_VIEW_CONSTS.NO_PODCAST_ADDED,
    MSG: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_FIRST_PODCAST,
  },
  CUSTOM: {
    TITLE: PORTFOLIO_BANNER_VIEW_CONSTS.NO_CUSTOM_ADDED,
    MSG: PORTFOLIO_BANNER_VIEW_CONSTS.NO_CUSTOM_ADDED_MSG,
  },
};

export const PORTFOLIO_ITEM_MSG = {
  MUSIC: {
    TITLE: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_FIRST_ALBUM,
    MSG: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_FIRST_ALBUM,
  },
  VIDEO: {
    TITLE: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_FIRST_VIDEO,
    MSG: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_FIRST_VIDEO,
  },
  PODCAST: {
    TITLE: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_FIRST_PODCAST,
    MSG: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_FIRST_PODCAST,
  },
  CUSTOM: {
    TITLE: PORTFOLIO_BANNER_VIEW_CONSTS.NO_COLLECTION_ADDED,
    MSG: PORTFOLIO_BANNER_VIEW_CONSTS.ADD_FIRST_COLLECTION,
  },
}

export const PORTFOLIO_TAB_LABEL_MAP = {
  MUSIC: {
    SINGLE: PORTFOLIO_BANNER_VIEW_CONSTS.SINGLE_SONGS,
    MASTER: PORTFOLIO_BANNER_VIEW_CONSTS.ALBUMS,
  },
  VIDEO: {
    SINGLE: PORTFOLIO_BANNER_VIEW_CONSTS.SINGLE_VIDEOS,
    MASTER: PORTFOLIO_BANNER_VIEW_CONSTS.VIDEO_SERIES,
  },
  PODCAST: {
    SINGLE: PORTFOLIO_BANNER_VIEW_CONSTS.SINGLE_EPISODES,
    MASTER: PORTFOLIO_BANNER_VIEW_CONSTS.PODCAST_SERIES,
  },
  CUSTOM: {
    SINGLE: PORTFOLIO_BANNER_VIEW_CONSTS.SINGLE_ITEMS,
    MASTER: PORTFOLIO_BANNER_VIEW_CONSTS.COLLECTIONS,
  },
}